/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  branch Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  ADD_BILL(state, bill) {
    if (bill.status == 2) {
      state.completeBills.unshift(bill);
      state.completeBillsTotal++;
    } else if (bill.status == 1) {
      state.inCompleteBills.unshift(bill);
      state.inCompleteBillsTotal++;
    }
  },
  REMOVE_BILL(state, id) {
    let x = state.completeBills.some(x => x.id == id);
    if (x) {
      let index = state.completeBills.findIndex((p) => p.id == id)
      if(index >= 0)
      state.completeBills.splice(index, 1);
    }
    else{
      let index = state.inCompleteBills.findIndex((p) => p.id == id)
      if(index >= 0)
      state.inCompleteBills.splice(index,1);
    }
  },
  SET_BILLS(state, res) {
    state.inCompleteBills = res.awaitBills.items;
    state.inCompleteBillsTotal = res.awaitBills.totalCount;

    state.completeBillsTotal = res.completeBills.totalCount;
    state.completeBills = res.completeBills.items;
  },
  UPDATE_BILL(state, updatedBill) {
    let theBillIndex = state.inCompleteBills.findIndex(x => x.id == updatedBill.id);
    if (updatedBill.status == "InComplete") Object.assign(state.inCompleteBills[theBillIndex], updatedBill);
    else if (updatedBill.status == "Complete") {
      state.inCompleteBills.splice(theBillIndex, 1);
      state.completeBills.unshift(updatedBill);
      state.completeBillsTotal++;
    }
  }
}
